<template>
    <v-form ref="passwordFurtherAssistance" v-model="valid" lazy-validation>
        <div class="password-recovery">
            <div class="password-recovery__title">{{loginConstants.ENTER_REQUIRED_INFO}}</div>
        </div>
        <div class="password-recovery__members" v-if="!confirmedApiResponse">{{loginConstants.MEMBERS_DATE_OF_BIRTH}}</div>
        <v-layout row v-if="!confirmedApiResponse">
            <v-flex>
                <div class="date-of-birth">
                    <v-menu ref="menu"
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            max-width="290px">
                        <v-text-field slot="activator"
                                      id="birth_date_input"
                                      data-qe-id="birth_date_input"
                                      v-model="user.birthDate"
                                      prepend-inner-icon="event"
                                      :rules="birthDateRules"
                                      :disabled="isSubmitting"
                                      required
                                      readonly></v-text-field>
                        <v-date-picker ref="picker"
                                       v-model="user.birthDate"
                                       :max="new Date().toISOString().substr(0, 10)"
                                       min="1900-01-01"
                                       @change="save"></v-date-picker>
                    </v-menu>
                </div>
            </v-flex>
        </v-layout>
        <div class="password-recovery__members" v-if="!confirmedApiResponse">{{loginConstants.MEMBERS_LAST_NAME}}</div>
        <v-layout row v-if="!confirmedApiResponse">
            <v-text-field id="last_name_input"
                          data-qe-id="last_name_input"
                          name="LastName"
                          v-model="user.lastName"
                          :rules="lastNameRules"
                          :disabled="isSubmitting"
                          :onkeyup="resetError()"
                          required
                          v-on:keydown.enter.prevent></v-text-field>
        </v-layout>
        <login-error></login-error>
        <v-card-actions>
            <v-layout row wrap>
                <v-btn flat
                       large
                       id="return_to_home_btn"
                       data-qe-id="return_to_home_btn"
                       block
                       :class="confirmedApiResponse ? 'white--text' : 'ypo_blue--text'"
                       :color="confirmedApiResponse ? 'ypo_gold' : ''"
                       @click="returnToLogin()"
                       :disabled="isSubmitting">
                    {{loginConstants.CANCEL}}
                </v-btn>
                <v-btn v-if="!confirmedApiResponse"
                       id="submit_password_recovery_btn"
                       data-qe-id="submit_password_recovery_btn"
                       color="ypo_blue"
                       class="white--text"
                       @click="submit"
                       :disabled="checkEmptyObject || !valid || isSubmitting"
                       large
                       block>
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
        <v-layout column class="text-center" pt-4>
            <v-flex xs12 class="spouse-partner__label">{{loginConstants.ARE_YOU_SPOUSE_PARTNER}}</v-flex>
            <v-flex xs12 class="spouse-partner__link">
                  <span @click="changeCardState(loginConstants.componentNames.spousePartnerResetPassword.component)"
                        data-qe-id="spouse-partner_assistance_link">
                      {{loginConstants.SPOUSE_PARTNER_PASSWORD_ASSISTANCE_LINK}}
                  </span>
            </v-flex>
        </v-layout>
    </v-form>
</template>
<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from "../LoginError";
    import { storeMutation } from "../../../store/storeMutations.constant";

    export default {
        name: 'PasswordFurtherAssistance',
        components: { LoginError },
        data: () => ({
            loginConstants,
            valid: false,
            error: '',
            componentNames: loginConstants.componentNames,
            user: {
                birthDate: null,
                lastName: null,
            },
            menu: false,
            confirmedApiResponse: null,
            lastNameRules: [
                v => !!v || loginConstants.errors.LAST_NAME_IS_REQUIRED,
            ],
            birthDateRules: [
                v => !!v || loginConstants.errors.BIRTHDATE_REQUIRED,
            ],
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        watch: {
            menu(val) {
                if (val) {
                    this.$nextTick(() => { this.$refs.picker.activePicker = 'YEAR'; });
                }
            },
        },
        methods: {
            ...mapActions({
                submitPasswordFurtherAssistance: `auth/${storeAction.submitPasswordFurtherAssistance}`,
                clearErrorOnStateChange: `auth/${storeAction.handleLoginErrorMessage}`,
            }),
            ...mapMutations({
                setMemberFurtherSecurityObject: `auth/${storeMutation.prepareAdditionalSecurityObjectForPassword}`,
            }),
            submit() {
                this.toggleProgressIndicator();

                if (this.$refs.passwordFurtherAssistance.validate()) {
                    this.submitPasswordFurtherAssistance(this.user)
                        .then((resp) => {
                            this.toggleProgressIndicator();
                            if (resp.data && resp.data.duplicateUserFound) {
                                this.setMemberFurtherSecurityObject(this.user);
                                this.changeCardState(this.componentNames.furtherSecurity.component);
                            } else {
                                this.confirmedApiResponse = resp.data;
                                this.changeCardState(this.componentNames.selectTypePasswordDelivery.component);
                            }
                        })
                        .catch(() => {
                            //TODO: handle error
                            this.toggleProgressIndicator();
                        });
                }
            },
            resetError() {
                if (!(this.user.birthDate && this.user.lastName)) {
                    this.clearErrorOnStateChange(null);
                }
            },
            save(date) {
                this.$refs.menu.save(date);
            },
        },
        computed: {
            ...mapGetters({
                recoveryData: storeGetters.recoveryData,
            }),
            checkEmptyObject() {
                return Object.values(this.user).some((x) => {
                    return x === null || x === '';
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';
    @import '../../../common/styles/_responsive.scss';

    .password-recovery {
        display: flex;
        flex-direction: column;

        &__title {
            padding: 5px 10px 20px 5px;
            font-size: 16px;
            color:$black;
            opacity: 0.9;
        }

        &__subTitle {
            padding: 5px 10px 20px;
            text-align: center;
            font-size: 16px;
            color: $ypo-blue;
        }


        &__success {
            padding: 10px 5px;
            border-top: 1px solid $ypo-gray;
            display: flex;
            flex-wrap: wrap;

            &-message {
                color: $ypo-blue;
            }

            &-email {
                color: $ypo-gold;
                padding-left: 5px;
            }
        }

        &__resend {
            color: $ypo-blue-secondary;
        }

        &__members {
            font-size: 14px;
            font-weight: bold;
            line-height: 24px;
            height: 24px;
            width: 312px;
            margin-bottom: -12px;
            margin-top: 12px;
        }
    }
    .v-btn__content{
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding-right: 0 !important;
        padding-left: 0 !important;
        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }

    .date-of-birth, .month-of-birth {
        padding-right: 10px;
    }

    .spouse-partner {
        &__label {
            color: $ypo-blue;
            font-weight: 600;
            margin-bottom: 5px;
        }

        &__link {
            color: $ypo-gold;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }


</style>
